import React from 'react'
import '../Contact.css';

const ContactHead = () => {
  return (
     <div className='container-fluid contacthead w-100 px-5 py-3'>
      <h1 className='fw-bolder ourLandingAnimate'>Contact</h1>
    </div>
  )
}

export default ContactHead
